// Define the possible component actions for the reducer to call.
export const ACTIONS = {
  SELECT_AD_GROUP: "selectADGroup",
  SELECT_GROUP_MEMBER: "selectGroupMember",
  SET_EMAIL: "setEmail",
  TOGGLE_LOADING: "toggleLoading",
  SET_STATUS: "setStatus",
  VALIDATE_FORM: "validateForm",
};

// Define the state's initial values.
export const initialState = {
  newMember: "Add Member",
  selectedGroupMember: {
    value: "",
    label: "Search Members...",
  },
  selectedADGroup: {
    value: "",
    label: "Search Collector AD Groups...",
  },
  email: "",
  emailError: false,
  formValid: false,
  loading: false,
  status: "",
};

const validateForm = (state) => {
  return !(state?.selectedGroupMember?.value
    ? state.selectedGroupMember.value === state.newMember &&
      (!state.email || (state.email?.length > 0 && state.emailError))
    : true);
};

// Define the component's reducer with an action switch and state handling.
export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SELECT_AD_GROUP:
      return {
        ...state,
        selectedADGroup: action.value,
        selectedGroupMember: initialState.selectedGroupMember,
        email: "",
        emailError: false,
        status: "",
      };
    case ACTIONS.SELECT_GROUP_MEMBER:
      return {
        ...state,
        selectedGroupMember: action.value,
        email: "",
        emailError: false,
        status: "",
      };
    case ACTIONS.SET_EMAIL:
      return {
        ...state,
        email: action.value,
        status: "",
        emailError:
          action.value?.length === 0
            ? false
            : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(action.value),
      };
    case ACTIONS.TOGGLE_LOADING:
      return {
        ...state,
        loading: state.loading === true ? false : true,
      };
    case ACTIONS.SET_STATUS:
      return {
        ...state,
        status: action.value,
        loading: false,
        email: "",
      };
    case ACTIONS.VALIDATE_FORM:
      return {
        ...state,
        formValid: validateForm(state),
      };
    default:
      return state;
  }
};
